module.exports = __webpack_public_path__ + "pic/5.847353ec.png";